export const SubmissionGroupByTypes = {
    REVIEW_STATUS: 'reviewStatus',
    CATEGORY: 'category',
}

export const getSubmissionGroupByName = value => {
    switch (value) {
        case SubmissionGroupByTypes.REVIEW_STATUS:
            return 'Review status'
        case SubmissionGroupByTypes.CATEGORY:
            return 'Category'
        default:
            return 'Unknown Group by Type'
    }
}

export const DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_ALL_QUESTIONS_PAGE = SubmissionGroupByTypes.REVIEW_STATUS
export const DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_QUESTION_PAGE = SubmissionGroupByTypes.CATEGORY
